"use strict";
// Use an Immediately Invoked Function Expression (IIFE) to avoid polluting global scope
;
(function () {
    // Create a global marker to track if this has already run
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.__BROWSER_COMPATIBILITY_CHECK_RUN__) {
        return; // Exit early if already run
    }
    // Set marker to prevent running again
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.__BROWSER_COMPATIBILITY_CHECK_RUN__ = true;
    // Run on DOM content loaded
    document.addEventListener("DOMContentLoaded", function () {
        var ua = window.navigator.userAgent;
        // Check for Internet Explorer
        var isIE = /MSIE|Trident/.test(ua);
        // Check for Edge (non-Chromium) older than version 18
        var oldEdgeMatch = ua.match(/Edge\/(\d+)/);
        var isOldEdge = oldEdgeMatch && parseInt(oldEdgeMatch[1], 10) < 18;
        if (isIE || isOldEdge) {
            alert("This website is not fully compatible with your browser. Please switch to Microsoft Edge (Chromium), Chrome, Firefox, or Safari for the best experience.");
        }
    });
    // Check for CSS :has selector support - run immediately
    if (!CSS.supports("selector(:has(*))")) {
        alert("Your browser does not support some of the features of this site. Please update your browser.");
    }
})();
